import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

export class TopicSimple<T extends EMode = EMode.entity> {
  /** Alias: code */
  id?: number;
  /** Alias: name */
  name?: string;

  __typename?: string;
}

const fields: FieldDefinitions<TopicSimple> = {
  id: {
    alias: 'code',
  },
  name: {
    alias: 'name',
  },
  __typename: {
    alias: '__typename',
  },
};

export const topicSimpleEntityDefinition: EntitiyDefinition<TopicSimple> = {
  local: {},
  remote: {
    queryName: 'getThemen',
    fragmentName: 'ThemaSimple',
    withPaginationWrapper: false,
    params: [{ name: 'typeOfCrm', type: 'TypeOfCrm!' }],
  },
  fieldDefinitions: fields,
};
